import { navItemAllowed } from "../lib/master";

/** Twelve-link executive chain trace — read-only links to existing routes. */
export default function ChainTrace({ app, guide, onOpen, testId = "chain-trace" }) {
  const trace = app?.chain_trace || app?.brd?.executive_trace || [];
  if (!trace.length) return null;

  return (
    <div className="exec-trace chain-trace-panel" data-testid={testId}>
      <p className="kicker">EXECUTIVE CHAIN · STRATEGY → VALUE</p>
      <p className="muted small-note">One credible pass through the governed decision chain — links only, no new routes.</p>
      <div className="exec-trace-row chain-trace-grid">
        {trace.map((node, i) => {
          const openable = navItemAllowed(node.route?.split("?")[0] || node.route, guide) && onOpen;
          const Tag = openable ? "button" : "div";
          return (
            <Tag
              type={openable ? "button" : undefined}
              key={node.id}
              className={`exec-trace-node status-${node.status || "partial"}`}
              data-testid={`chain-trace-${node.id}`}
              onClick={openable ? () => onOpen(node.route) : undefined}
            >
              <small>{String(i + 1).padStart(2, "0")}</small>
              <strong>{node.label}</strong>
              <span>{node.value}</span>
            </Tag>
          );
        })}
      </div>
    </div>
  );
}
